import { render, staticRenderFns } from "./StatesSelect.vue?vue&type=template&id=98cfd474&"
import script from "./StatesSelect.vue?vue&type=script&lang=ts&"
export * from "./StatesSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports